<!--
 * @Descripttion: 首页组件
 * @Author: congz
 * @Date: 2020-06-04 11:22:40
 * @LastEditors: congz
 * @LastEditTime: 2020-08-12 21:20:08
--> 

<template>
  <div class="home" id="home" name="home">
    <!-- Hero Section -->
    <div class="hero">
      <div class="hero-banner" :style="{ backgroundImage: `url(${currentHeroImage})` }">
        <div class="hero-overlay">
          <div class="hero-title">Fresh from the Farm.</div>
          <div class="hero-desc">
            Fruits and vegetables picked at dawn, graded, cleaned and packed the same day. Honest pack sizes, everyday low prices, delivered across Tamil Nadu.
          </div>
          <router-link class="hero-btn" to="/goods">Shop Now</router-link>
        </div>
        <div class="hero-dots">
          <span
            v-for="(img, idx) in heroImages"
            :key="idx"
            class="hero-dot"
            :class="{ active: heroIndex === idx }"
            @click="setHeroIndex(idx)"
          ></span>
        </div>
      </div>
    </div>

    <!-- Category Products Section -->
    <div class="main-box">
      <div class="main">
        <div class="section-header">
          <h2>Fresh Arrivals</h2>
          <p>Picked this morning, packed the same day</p>
        </div>
        <div class="category-products">
          <ProductGrid :list="homeProducts" :isMore="false"></ProductGrid>
        </div>

        <!-- Why Shop With Us -->
        <div class="why-section">
          <div class="why-item">
            <div class="why-icon">🚚</div>
            <h3>Free Shipping</h3>
            <p>On orders above ₹499</p>
          </div>
          <div class="why-item">
            <div class="why-icon">🌿</div>
            <h3>Farm Fresh</h3>
            <p>Graded, cleaned &amp; quality-checked</p>
          </div>
          <div class="why-item">
            <div class="why-icon">🔄</div>
            <h3>Fresh Guarantee</h3>
            <p>Replacement if it isn't fresh</p>
          </div>
          <div class="why-item">
            <div class="why-icon">💳</div>
            <h3>Secure Payment</h3>
            <p>UPI, COD &amp; cards accepted</p>
          </div>
        </div>

        <!-- Shop By Category Tiles -->
        <div class="home-section cat-section">
          <div class="home-section-header">
            <div>
              <h2>Shop By Category</h2>
              <p>Fruit crates and vegetable baskets</p>
            </div>
            <router-link class="section-cta" to="/goods">See All</router-link>
          </div>
          <div class="cat-tiles">
            <router-link
              v-for="tile in categoryTiles"
              :key="tile.id"
              class="cat-tile"
              :to="`/goods?categoryID=${tile.id}`"
            >
              <span class="cat-tile-accent"></span>
              <img :src="tile.img" :alt="tile.name" loading="lazy" />
              <span class="cat-tile-label">{{ tile.name }}</span>
            </router-link>
          </div>
        </div>

        <!-- Discover Section -->
        <div class="home-section">
          <div class="home-section-header">
            <div>
              <h2>Shop The Edit</h2>
              <p>From the fruit crate to the greens basket</p>
            </div>
            <div class="section-tabs">
              <span
                v-for="tab in discoverTabs"
                :key="tab.key"
                class="tab-item"
                :class="{active: discoverActive===tab.key}"
                @click="discoverActive=tab.key"
              >{{ tab.label }}</span>
            </div>
          </div>
          <ProductGrid :list="discoverProducts" :isMore="false"></ProductGrid>
          <router-link class="section-cta" to="/goods">See More</router-link>
        </div>

        <!-- Full Width Promo Banner -->
        <div class="promo-full-banner">
          <div class="promo-content">
            <span class="promo-tag">This Week's Offer</span>
            <h2>THE FRESH EDIT</h2>
            <p>Up to 30% Off on Seasonal Fruits &amp; Everyday Vegetables</p>
            <router-link class="promo-btn" to="/goods">Shop Now</router-link>
          </div>
          <div class="promo-image">
            <img src="https://www.bbassets.com/media/uploads/p/l/30001006_8-fresho-alphonso-mango-ratnagiri.jpg" alt="Fresho Alphonso Mango - Ratnagiri" />
          </div>
        </div>

        <!-- Split Banners -->
        <div class="split-banners-grid">
          <div class="split-banner">
            <div class="split-content">
              <div class="split-title">Exotic &amp; Premium Fruits</div>
              <div class="split-desc">
                Dragon fruit, kiwi, avocado, imported cherries and peaches — the special-occasion crate, graded by size and packed the day it is picked.
              </div>
              <router-link class="section-cta" to="/goods?categoryID=601">Explore Now</router-link>
            </div>
            <div class="split-image">
               <img src="https://www.bbassets.com/media/uploads/p/l/40219746_1-fresho-dragon-fruit-organic-white.jpg" alt="Fresho Dragon Fruit - Organic, White" />
            </div>
          </div>
          <div class="split-banner">
            <div class="split-content">
              <div class="split-title">Leafy Greens &amp; Fresh Herbs</div>
              <div class="split-desc">
                Coriander, spinach, lettuce, pak choi and living microgreens — cut at dawn, kept cool, and delivered with the rest of your basket.
              </div>
              <router-link class="section-cta" to="/goods?categoryID=602">Explore Now</router-link>
            </div>
            <div class="split-image">
               <img src="https://www.bbassets.com/media/uploads/p/l/20000922_10-fresho-lettuce-iceberg.jpg" alt="Fresho Lettuce - Iceberg 250 g" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as productsAPI from '@/api/products/'
import * as categoryAPI from '@/api/categories/'
import ProductGrid from '@/components/ProductGrid'

export default {
  components: { ProductGrid },
  data() {
    return {
      carousels: [], // 轮播图数据（后端接口，已忽略：Hero 由下方精选男装图池提供）
      // Discover 区：只保留果蔬 4 个分类 tab（600-603），饮料类已全部下线
      discoverTabs: [
        { key: 'FRUITS', id: 600, label: 'FRESH FRUITS' },
        { key: 'EXOTIC', id: 601, label: 'EXOTIC FRUITS' },
        { key: 'LEAFY', id: 602, label: 'LEAFY GREENS' },
        { key: 'VEG', id: 603, label: 'VEGETABLES' }
      ],
      discoverActive: 'FRUITS', // Discover section active tab
      discoverLists: {}, // key -> 商品列表
      // Shop By Category 分类卡片（只保留果蔬 4 张，饮料类已全部下线）
      categoryTiles: [
        { id: 600, name: 'Fresh Fruits', img: 'https://www.bbassets.com/media/uploads/p/l/10000394_6-fresho-apple-ambri.jpg' },
        { id: 601, name: 'Exotic Fruits', img: 'https://www.bbassets.com/media/uploads/p/l/30009284_8-fresho-avocado-imported-medium.jpg' },
        { id: 602, name: 'Leafy Greens', img: 'https://www.bbassets.com/media/uploads/p/l/40221591_1-fresho-coriander-hydroponically-grown.jpg' },
        { id: 603, name: 'Vegetables', img: 'https://www.bbassets.com/media/uploads/p/l/40247772_1-fresho-tomato-beefsteak-juicy-fresh.jpg' }
      ],
      // Hero 轮播：精选男装图池（OSS shop5 路径，来自 sql/男装.sql img_path）
      heroImages: [
        require('@/assets/imgs/hero_basket.jpg'),                                        // 生成的主视觉：藤篮 + 果蔬
        'https://www.bbassets.com/media/uploads/p/l/10000394_6-fresho-apple-ambri.jpg',   // Fresho Apple - Ambri 1 kg
        'https://www.bbassets.com/media/uploads/p/l/30001006_8-fresho-alphonso-mango-ratnagiri.jpg',   // Fresho Alphonso Mango - Ratnagiri
        'https://www.bbassets.com/media/uploads/p/l/40247772_1-fresho-tomato-beefsteak-juicy-fresh.jpg'   // Fresho Tomato - Beefsteak
      ],
      heroIndex: 0,
      heroTimer: null,
      start: 0,
      limit: 7,
      homeCategories: [],
      activeCategoryId: 0,
      homeProducts: [],
      homeStart: 0,
      homeLimit: 8
    }
  },
  computed: {
    currentHeroImage() {
      // 直接使用精选男装图池，忽略后端 carousels
      return this.heroImages[this.heroIndex] || this.heroImages[0]
    },
    discoverProducts() {
      return this.discoverLists[this.discoverActive] || []
    }
  },
  activated() {
    // 获取首页数据
    this.load()
    this.startHeroRotation()
  },
  deactivated() {
    this.stopHeroRotation()
  },
  beforeDestroy() {
    this.stopHeroRotation()
  },
  methods: {
    // Hero 轮播控制
    setHeroIndex(idx) {
      this.heroIndex = idx
    },
    startHeroRotation() {
      this.stopHeroRotation()
      if (!this.heroImages || this.heroImages.length < 2) return
      this.heroTimer = setInterval(() => {
        this.heroIndex = (this.heroIndex + 1) % this.heroImages.length
      }, 5000)
    },
    stopHeroRotation() {
      if (this.heroTimer) {
        clearInterval(this.heroTimer)
        this.heroTimer = null
      }
    },
    load() {
      // 不再请求后端 carousels 接口。Hero 轮播由精选男装图池提供。
      // 首页类目：取导航“Shop Now”同源分类
      categoryAPI
        .listCategories()
        .then(res => {
          if (res.status === 200) {
            const list = Array.isArray(res.data) ? res.data : []
            this.homeCategories = [{ category_id: 0, category_name: 'All' }, ...list]
            this.activeCategoryId = 0
            this.fetchHomeProducts(0)
          } else {
            this.notifyError('Failed to obtain classification', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Failed to obtain classification', err)
        })
      // Discover section: 只拉果蔬 4 个分类（600-603）
      this.loadDiscover()
    },
    // Discover 区：按 4 个 tab 拉取商品
    loadDiscover() {
      this.discoverTabs.forEach(tab => {
        productsAPI
          .listProducts(tab.id, 0, this.limit)
          .then(res => {
            if (res.status === 200) {
              this.$set(this.discoverLists, tab.key, this.shuffle((res.data && res.data.items) || []))
            }
          })
          .catch(() => {})
      })
    },
    fetchHomeProducts(categoryId) {
      productsAPI
        .listProducts(categoryId, this.homeStart, this.homeLimit)
        .then(res => {
          if (res.status === 200) {
            this.homeProducts = this.shuffle(Array.isArray(res.data.items) ? res.data.items : [])
          } else {
            this.notifyError('Failed', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Failed', err)
        })
    },
    // Fisher-Yates shuffle
    shuffle(array) {
      const arr = [...array]
      for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1))
        ;[arr[i], arr[j]] = [arr[j], arr[i]]
      }
      return arr
    }
  },
  beforeRouteEnter(to, from, next) {
    // 添加背景色
    document
      .querySelector('body')
      .setAttribute('style', 'background-color:#FFFFFF')
    next()
  },
  beforeRouteLeave(to, from, next) {
    // 去除背景色
    document
      .querySelector('body')
      .setAttribute('style', 'background-color:#FFFFFF')
    next()
  }
}
</script>
<style scoped>
@import '../assets/css/index.css';

/* Shop By Category Tiles（SRI BASKET） */
.cat-section .cat-tiles {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
  margin: 8px 0 44px;
}
.cat-section .cat-tile {
  position: relative;
  display: block;
  border-radius: 14px;
  overflow: hidden;
  background: #f6f7f4;
  text-decoration: none;
}
.cat-section .cat-tile img {
  width: 100%;
  height: 230px;
  object-fit: cover;
  display: block;
  transition: transform 0.35s ease;
}
.cat-section .cat-tile:hover img {
  transform: scale(1.05);
}
.cat-section .cat-tile-accent {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 2;
  width: 36px;
  height: 4px;
  border-radius: 2px;
  background: #ff7a18;
}
.cat-section .cat-tile-label {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 22px 14px 12px;
  background: linear-gradient(180deg, rgba(16, 37, 26, 0) 0%, rgba(16, 37, 26, 0.85) 100%);
  color: #FFFFFF;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
}
@media (max-width: 900px) {
  .cat-section .cat-tiles {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
  }
  .cat-section .cat-tile img {
    height: 160px;
  }
}
</style>
